module.exports = require("vtk.js/Sources/Common/Core/DataArray");